<template>
    <div class="input-date">

        <!-- 日期選擇 -->
        <div>
            <date-picker v-model="dateRange" range
                        ref="datepickerRange"
                        :lang="$tools.lang.date_picker(language)"
                        :width="'250px'"
                        :shortcuts="date_shortcuts"
                        :placeholder="$t('menu.select_date_range')"
                        :not-before="date_bounding_start"
                        :not-after="date_bounding_end"
                        format="YYYY-MM-DD" >
            </date-picker>
        </div>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import DatePicker from 'vue2-datepicker'

export default {
    components: {
        DatePicker,
    },
    props: {
        timezone: {
            type: String,
            default: 'Asia/Taipei',
        },
        query_start_date: {
            type: String,
            default: '2001-01-01',
        },
        query_end_date: {
            type: String,
            default: undefined,
        },
        no_bounding: {          // 不設定開始日期限制，結束日期到今天
            type: Boolean,
            default: false,
        },
        shortcut_no_shift: {    // 快捷鍵不要往前移一天 (歷史資料有限制取前一天資料)
            type: Boolean,
            default: false,
        },
        default_query: {
            type: Array,
            default: function () { return [ undefined, undefined ] },
        },
    },
    data () {
        return {

            // [ DatePicker ]
            dateRange: '',

            // [ Default ]
            date_today: undefined,
        }
    },
    mounted ()
    {
        this.date_today = this.$tools.date.getDateNow(this.timezone, 'YYYY-MM-DD 23:59');
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'user_admin': state => state.user.is_admin,
        }),
        
        // DatePicker
        date_shortcuts ()
        {
            let _End_Day_shift = ( this.shortcut_no_shift ? 0 : -1 )
            return [
                {
                    text: this.$t('menu.date_previous') + ' 7 ' + this.$t('u.days'),
                    onClick: () => {
                        let _dateNow = this.$tools.date.getDateShift( this.date_today, _End_Day_shift, 'days' ); // 取前一天資料
                        let _dateStart = this.query_start_date;
                        if ( this.$tools.date.countDays( _dateStart, _dateNow ) > 6 )
                        {
                            _dateStart = this.$tools.date.getDateShift(_dateNow, -6, 'days', 'YYYY-MM-DD 00:00');
                        }
                        this.dateRange = [ _dateStart, _dateNow ]
                    }
                },
                {
                    text: this.$t('menu.date_previous') + ' 30 ' + this.$t('u.days'),
                    onClick: () => {
                        let _dateNow = this.$tools.date.getDateShift( this.date_today, _End_Day_shift, 'days' ); // 取前一天資料
                        let _dateStart = this.query_start_date;
                        if ( this.$tools.date.countDays( _dateStart, _dateNow ) > 29 )
                        {
                            _dateStart = this.$tools.date.getDateShift(_dateNow, -29, 'days', 'YYYY-MM-DD 00:00');
                        }
                        this.dateRange = [ _dateStart, _dateNow ]
                    }
                },
                {
                    text: this.$t('menu.date_previous') + ' 60 ' + this.$t('u.days'),
                    onClick: () => {
                        let _dateNow = this.$tools.date.getDateShift( this.date_today, _End_Day_shift, 'days' ); // 取前一天資料
                        let _dateStart = this.query_start_date;
                        if ( this.$tools.date.countDays( _dateStart, _dateNow ) > 59 )
                        {
                            _dateStart = this.$tools.date.getDateShift(_dateNow, -59, 'days', 'YYYY-MM-DD 00:00');
                        }
                        this.dateRange = [ _dateStart, _dateNow ]
                    }
                },
                {
                    text: this.$t('menu.close'), // CEO 很愛用手機點，為了讓他不被擋住加了一個關閉按鈕
                    onClick: () => {
                        this.$refs.datepickerRange.closePopup();
                    }
                },
            ]
        },
        date_bounding_start ()
        {
            if (this.no_bounding) return undefined

            return ( this.query_start_date ? this.query_start_date : this.date_today )
        },
        date_bounding_end ()
        {
            if (this.no_bounding) return this.date_today

            return ( this.query_end_date ? this.query_end_date : this.$tools.date.getDateShift( this.date_today, -1, 'days' ) )
        },

    },
    watch: {

        dateRange (val, oldVal)
        {
            this.emitValue( val );
        },

        default_query (val, oldVal)
        {
            if ( val[0] && val[1] )
            {
                this.dateRange = val
            }
        },

    },
    methods: {
        
        checkDateRangeErr (dateRange)
        {
            if (dateRange == '')            return true;
            if (dateRange == undefined)     return true;
            if (dateRange[0] == undefined)  return true;
            if (dateRange[1] == undefined)  return true;
            return false
        },

        emitValue (dateRange)
        {
            let _update_data = {};

            if ( this.checkDateRangeErr(dateRange) ) _update_data = undefined;

            if (_update_data)
            {
                _update_data.start_time = this.$moment( this.dateRange[0] ).format('YYYY-MM-DD 00:00:00');  // 開始的時間都是 00:00 開始
                _update_data.end_time   = this.$moment( this.dateRange[1] ).format('YYYY-MM-DD 23:59:59');  // 結束的時間都是 23:59 結束
            }
            this.$emit('date-range', _update_data);
        },


    }
}
</script>

<style lang="scss" scoped>

</style>
